var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { PureComponent } from 'react';
import { stringHash } from '../../Utils/string';
import { isValidUrl } from '@feb-team/data-logic';
import { Image } from './Image';
import checkWebp from './checkWebp';
import { defaultJDImageProps } from './defaults';
var IMAGE_DOMAIN_REGEXP = /(img\d\d|m).360buyimg\.com/;
var IMAGE_SERVER_DOMAIN = [
    'img10.360buyimg.com',
    'img11.360buyimg.com',
    'img12.360buyimg.com',
    'img13.360buyimg.com',
    'img14.360buyimg.com',
    'img20.360buyimg.com',
    'img30.360buyimg.com',
    'm.360buyimg.com',
];
var JDImage = /** @class */ (function (_super) {
    __extends(JDImage, _super);
    function JDImage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getFinalSrc = function () {
            var _a = _this.props, src = _a.src, businessName = _a.businessName, width = _a.width, height = _a.height, quality = _a.quality, enableWebp = _a.enableWebp;
            var finalSrc = src;
            if (!finalSrc) {
                console.warn('请输入正确的图片地址');
                return finalSrc;
            }
            var webpShow = checkWebp();
            if (!isValidUrl(finalSrc)) {
                var hash = stringHash(finalSrc);
                var domain = IMAGE_SERVER_DOMAIN[Math.abs(hash) % IMAGE_SERVER_DOMAIN.length];
                var scale = width && height ? "s" + width + "x" + height + "_" : '';
                finalSrc = "//" + domain + "/" + businessName + "/" + scale + finalSrc;
            }
            if (finalSrc.match(IMAGE_DOMAIN_REGEXP) && width && height && !finalSrc.match(/s\d+x\d+_/)) {
                var match = finalSrc.match(/(^(https?:)?\/\/[^/]+\/[^/]+\/)(.*)/);
                if (match) {
                    finalSrc = match[1] + "s" + width + "x" + height + "_" + match[3];
                }
            }
            if (finalSrc.match(IMAGE_DOMAIN_REGEXP)) {
                if (quality && quality > 0 && quality < 100 && !finalSrc.match(/!q\d+$/)) {
                    finalSrc = finalSrc + "!q" + quality;
                }
                if (enableWebp && webpShow && finalSrc.match(/\.(png|jpg)(!q\d+)?$/)) {
                    finalSrc = finalSrc + ".webp";
                }
            }
            return finalSrc;
        };
        return _this;
    }
    JDImage.prototype.render = function () {
        var _a = this.props, src = _a.src, businessName = _a.businessName, quality = _a.quality, rest = __rest(_a, ["src", "businessName", "quality"]);
        return (React.createElement(React.Fragment, null,
            React.createElement(Image, __assign({ src: this.getFinalSrc() }, rest))));
    };
    JDImage.defaultProps = defaultJDImageProps;
    return JDImage;
}(PureComponent));
export { JDImage };
